


















































































































import moment from "moment";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

// Vue components
import BranchHistoryIconBtn from "@/components/BranchHistoryIconBtn.vue";
import OldDataAlertIcon from "@/components/OldDataAlertIcon.vue";
import ServiceModeHistoryIconBtn from "@/components/ServiceModeHistoryIconBtn.vue";
import ConnectivityStatusChip from "@/views/App/Components/chips/ConnectivityStatusChip.vue";
import GlobalStatusInstallationChip from "@/views/App/Components/chips/GlobalStatusInstallationChip.vue";
import DateMomentTooltip from "../DateMomentTooltip.vue";
import VFaIcon from "../VFaIcon.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { RefreshConnectivityStatusCommand } from "@/model/communication/status/RefreshConnectivityStatusCommand";
import { RefreshConnectivityStatusResData } from "@/model/communication/status/RefreshConnectivityStatusResData";
import { InstallationTypeEnum, installationTypeEnumLabel } from "@/model/data/enums/InstallationTypeEnum";
import { OsTypeEnum, osTypeEnumLabel } from "@/model/data/enums/OsTypeEnum";
import { Installation } from "@/model/data/Installation";
import { ServiceModeStatusEnum, serviceModeStatusEnumLabel } from "@/model/data/serviceMode/ServiceModeStatusEnum";
import { connectivityStatusDescription, ConnectivityStatusEnum } from "@/model/data/status/ConnectivityStatusEnum";
import { installationStatusDescription } from "@/model/data/status/InstallationStatusEnum";
import { TagKeyConverter } from "@/model/data/TagKeyConverter";
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";
import { RootState } from "@/store";

export default Vue.extend({
    components: { VFaIcon, BranchHistoryIconBtn, OldDataAlertIcon, ServiceModeHistoryIconBtn, DateMomentTooltip, ConnectivityStatusChip, GlobalStatusInstallationChip },
    data() {
        let displaySectionsList = [true, true, true, true, true];
        let value = LocalStorageManager.Read(LocalStorageRequests.DisplaySectionList);
        if (value) displaySectionsList = JSON.parse(LocalStorageManager.Read(LocalStorageRequests.DisplaySectionList));
        return {
            OsTypeEnum,
            InstallationTypeEnum,
            TagKeyConverter,
            ServiceModeStatusEnum,
            moment,
            loadingConnectivityStatus: false,
            refreshedConnectivityStatus: null,
            refreshIcon: "redo",
            displaySectionsList: displaySectionsList,
        };
    },
    props: {
        installation: { required: true, type: Installation },
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        connectivityStatus() {
            if (this.refreshedConnectivityStatus != null && this.refreshedConnectivityStatus != undefined) return this.refreshedConnectivityStatus;
            if (this.installation) return this.installation.connectivityStatus;
            return ConnectivityStatusEnum.Unknown;
        },
        borderLeftStyle() {
            if (this.userTheme == "dark") return "border-left: thin solid rgba(255, 255, 255, 0.3)";
            return "border-left: thin solid rgba(0, 0, 0, 0.12)";
        },
    },
    methods: {
        osTypeEnumLabel,
        installationTypeEnumLabel,
        serviceModeStatusEnumLabel,
        connectivityStatusDescription,
        installationStatusDescription,
        refreshConnectivityStatus() {
            this.sendRefreshConnectivityStatus();
        },
        async sendRefreshConnectivityStatus() {
            this.loadingConnectivityStatus = true;
            let response: RefreshConnectivityStatusResData = await new RefreshConnectivityStatusCommand(this.installation.name).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                if (this.installation.connectivityStatus != response.connectivityStatus) {
                    this.refreshedConnectivityStatus = response.connectivityStatus;
                    this.$emit("data-reload");
                }
            }
            this.loadingConnectivityStatus = false;
            this.refreshIcon = "check";
            await new Promise((res) => setTimeout(res, 1000));
            this.refreshIcon = "redo";
        },
        changeDisplaySectionValue(index: number, value: boolean) {
            this.displaySectionsList.splice(index, 1, value);
            LocalStorageManager.Write(LocalStorageRequests.DisplaySectionList, JSON.stringify(this.displaySectionsList));
            window.dispatchEvent(
                new CustomEvent("display-section-key-localstorage-changed", {
                    detail: {
                        index: index,
                        value: value,
                    },
                })
            );
        },
    },
    mounted() {
        window.addEventListener("display-section-key-localstorage-changed", (event: any) => {
            if (this.displaySectionsList[event.detail.index] != event.detail.value) {
                this.displaySectionsList.splice(event.detail.index, 1, event.detail.value);
            }
        });
    },
});
